module.exports = __webpack_public_path__ + "static/media/fj.c18b1479.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/fj.svg
// module id = 2088
// module chunks = 0